import { createFileRoute, Link } from "@tanstack/solid-router";
import { For } from "solid-js";
import { Card, CardContent, CardHeader, CardTitle } from "~/components/ui/card";
import { reportsRegistry } from "~/features/reports/reports-registry";

export const Route = createFileRoute("/_dashboard/dashboard/reports/")({
  component: ReportsIndexPage,
});

function ReportsIndexPage() {
  return (
    <div class="flex flex-1 flex-col gap-6 px-4 sm:px-6 pb-3 pt-6">
      <div>
        <h1 class="text-3xl font-bold">Reports</h1>
        <p class="text-muted-foreground">
          Select a report to view your financial statements.
        </p>
      </div>

      <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <For each={reportsRegistry}>
          {(report) => (
            <Link to={report.path} class="group">
              <Card class="h-full transition-colors group-hover:border-primary/50 group-hover:bg-accent/50">
                <CardHeader class="flex flex-row items-center gap-3 space-y-0">
                  <div class="flex size-10 items-center justify-center rounded-md bg-primary/10 text-primary">
                    <report.icon class="size-5" />
                  </div>
                  <CardTitle class="text-base">{report.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <p class="text-sm text-muted-foreground">
                    {report.description}
                  </p>
                </CardContent>
              </Card>
            </Link>
          )}
        </For>
      </div>
    </div>
  );
}
